import styled from "styled-components"


export const PreferencesPage = () => {
  return (
    <StyleWrap>
      PreferencesPage
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;